import { render, staticRenderFns } from "./VersionBanner.vue?vue&type=template&id=da5b1af6&scoped=true&"
import script from "./VersionBanner.vue?vue&type=script&lang=js&"
export * from "./VersionBanner.vue?vue&type=script&lang=js&"
import style0 from "./VersionBanner.vue?vue&type=style&index=0&id=da5b1af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5b1af6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
